import { INBOX_CHANNELS } from "./inboxNotificationTypes"

function inboxTitleFromRow(row) {
  return (
    row?.candidate_name ||
    row?.contact_name ||
    row?.from_address ||
    row?.from_phone ||
    "Unknown sender"
  )
}

function emailPreviewFromRow(row) {
  return row?.subject || row?.snippet || ""
}

function voicemailPreviewFromRow(row) {
  if (row?.transcript_snippet) {
    return row.transcript_snippet
  }
  if (row?.transcription_status === "pending") {
    return "Transcription in progress…"
  }
  if (row?.has_recording) {
    return "Voicemail recording available"
  }
  return "No recording"
}

export function normalizeEmailUnreadRow(row) {
  return {
    channel: INBOX_CHANNELS.email,
    id: row.thread_id,
    title: inboxTitleFromRow(row),
    preview: emailPreviewFromRow(row),
    date: row.latest_at || null,
    unreadCount: row.unread_count || 0,
  }
}

export function normalizeSmsUnreadRow(row) {
  return {
    channel: INBOX_CHANNELS.sms,
    id: row.thread_id,
    title: inboxTitleFromRow(row),
    preview: emailPreviewFromRow(row),
    date: row.latest_at || null,
    unreadCount: row.unread_count || 0,
  }
}

export function normalizeVoicemailUnreadRow(row) {
  return {
    channel: INBOX_CHANNELS.voicemail,
    id: row.id,
    title: inboxTitleFromRow(row),
    preview: voicemailPreviewFromRow(row),
    date: row.created || null,
    unreadCount: 1,
  }
}

export function sumInboxCounts({ voicemail = 0, email = 0, sms = 0 }) {
  return voicemail + email + sms
}

export function compareInboxNotificationsByDateDesc(left, right) {
  const leftTime = new Date(left?.date || 0).getTime()
  const rightTime = new Date(right?.date || 0).getTime()
  return rightTime - leftTime
}

export function sortInboxNotifications(notifications) {
  return [...(notifications || [])].sort(compareInboxNotificationsByDateDesc)
}
